function patternToRegex(pattern) {
    const regexString = pattern
        .split('/')
        .map(segment => {
            if (segment === '*') {
                return '.*';
            }
            if (segment.startsWith(':')) {
                const isOptional = segment.endsWith('?');
                if (isOptional) {
                    return '(?:[^/]+)?';
                }
                return '[^/]+';
            }
            return segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        })
        .join('/');

    return new RegExp(`^${regexString}$`);
}

function matchPath(pattern, pathname) {
    return patternToRegex(pattern).test(pathname);
}

export const isIncludesPath = (pathname, patterns) => {
    return patterns.some(pattern => matchPath(pattern, pathname));
}
//
// const publicPaths = [
//     '/user/login',
//     '/user/register',
//     '/unauthorized',
//     '/user/forgot-password',
//     '/user/reset-password/:hex',
//     '/user/:id/profile',
//     '/docs/*',          // any after /docs/
//     '/post/:id?',
// ];
//
// console.log(isPublicPath('/user/login', publicPaths));              // true
// console.log(isPublicPath('/user/reset-password/123abc', publicPaths)); // true
// console.log(isPublicPath('/user/42/profile', publicPaths));        // true
// console.log(isPublicPath('/docs/api/v1/test', publicPaths));       // true
// console.log(isPublicPath('/post', publicPaths));                   // true (бо :id?)
// console.log(isPublicPath('/post/999', publicPaths));               // true
// console.log(isPublicPath('/user/42/settings', publicPaths));       // false
